import _ from 'lodash';
import {meta} from '../../models/meta.js';

class ListController {
    constructor (Model) {
        this.Model = Model;
        this.items = [];
        this.pager = {
            currentPage: 1,
            limit: 15,
            totalItems: 0,
            search: "",
            start: 0,
            end: 0
        };
    }

    getState() {

    }

    getQueryset(params) {
        return this.Model.findAll(params);
    }

    getItems() {
        const params = {
            limit: this.pager.limit,
            offset: 0,
            search: this.pager.search,
        };

        if (params.search === '') {
            delete (params.search);
        }

        params.offset = (this.pager.currentPage - 1) * params.limit;

        return this.getQueryset(params).then((response) => {
            this.items = response;

            this.pager.start = parseInt(params.offset * (this.pager.currentPage-1)) + 1;
            this.pager.end = parseInt(params.offset * (this.pager.currentPage-1)) + response.length;

            if (meta[this.Model.name] !== undefined) {
                this.pager.totalItems = meta[this.Model.name].count;
                // this.pager.start = response.meta.start;
                // this.pager.end = response.meta.end;
            }

            return this.items;
        });
    }

    onFilter(value) {
        this.pager.search = value;
        this.getState();
    }

    pageChanged() {
        this.getState();
    }
}


export default ListController;



// WEBPACK FOOTER //
// ./app/components/common/list.controller.js